// PDF coordinates use a bottom-left origin. Anchor to printed labels, not saved offsets.
export function esirCoordinatesFromText(items) {
  const y = (label) => {
    const item = items.find(item => item.str.trim() === label);
    if (!item || !Number.isFinite(item.transform[5])) {
      throw new Error(`No se encuentra la etiqueta e-SIR: ${label}`);
    }
    return item.transform[5];
  };
  const delivery = y("Fecha entrega:");
  const reason = y("Motivo de rechazo");
  return {
    ycoord_amount: y("Cantidad (kg netos)"),
    ycoord_deliver_date: delivery,
    ycoord_delivery_quantity: delivery,
    ycoord_accept: delivery,
    ycoord_date_accepted: y("Fecha aceptación/rechazo"),
    ycoord_action_refund: y("Acción en caso de rechazo"),
    ycoord_date_refund: y("Fecha devolución/reenvío"),
    ycoord_reason_refund: reason,
    ycoordsignaturerefund: reason - 28,
  };
}
